(function () {
  "use strict";

  // Prevent duplicate events
  var lastEvent = "";

  document.addEventListener(
    "cart:update",
    function (event) {
      try {
        if (!event.detail || !event.detail.data) return;

        // Ignore failed add-to-cart
        if (event.detail.data.didError) return;

        // Only fire for Product Form AddToCart
        if (event.detail.data.source !== "product-form-component") return;

        // -------------------------
        // Variant ID (Safely checking without ?.)
        // -------------------------
        var variantId =
          event.detail.sourceId ||
          event.detail.data.variantId ||
          (event.detail.resource && event.detail.resource.variant_id) ||
          (event.detail.resource && event.detail.resource.id);

        if (!variantId) {
          console.warn("No variant ID found.");
          return;
        }

        // -------------------------
        // Quantity
        // -------------------------
        var quantity = Number(event.detail.data.itemCount || 1);

        // -------------------------
        // Prevent duplicate firing
        // -------------------------
        var uniqueKey = variantId + "_" + quantity;

        if (lastEvent === uniqueKey) return;

        lastEvent = uniqueKey;

        // Reset after 1 second
        setTimeout(function () {
          lastEvent = "";
        }, 1000);

        // -------------------------
        // Meta Pixel check
        // -------------------------
        if (typeof fbq !== "function") {
          console.warn("Meta Pixel not loaded.");
          return;
        }

        // -------------------------
        // Variant data (Safely checking without ?.)
        // -------------------------
        var variant = {};
        if (
          window.meta &&
          window.meta.product &&
          window.meta.product.variants
        ) {
          variant =
            window.meta.product.variants.find(function (v) {
              return String(v.id) === String(variantId);
            }) || {};
        }

        // Shopify stores price in paise/cents
        var value = variant.price ? variant.price / 100 : 0;
        var productName = variant.name || "";
        var sku = variant.sku || "";

        // -------------------------
        // Currency (Safely checking without ?.)
        // -------------------------
        var currency = "INR";
        if (window.Shopify && window.Shopify.currency) {
          currency =
            window.Shopify.currency.active ||
            window.Shopify.currency.iso_code ||
            "INR";
        }

        // -------------------------
        // Fire Meta Event
        // -------------------------
        fbq("track", "AddToCart", {
          content_ids: [String(variantId)],
          content_type: "product",
          content_name: productName,
          value: value,
          currency: currency,
          num_items: quantity
        });

        console.log("✅ Meta AddToCart Fired", {
          variantId: variantId,
          quantity: quantity,
          value: value,
          currency: currency,
          productName: productName,
          sku: sku
        });
      } catch (err) {
        console.error("Meta AddToCart Error:", err);
      }
    },
    true
  );
})();